<ng-template #tonality>
  <td class='tonality-column'>
    <div [style.minWidth.px]='tonalityColumnWidth' [style.width.px]='tonalityColumnWidth' [hidden]='!lessonPrefs.tonalityShown'>
      <p [ngClass]='song.isNonmajor ? "bold" : ""'>{{song.formattedTonality}}</p>
    </div>
  </td>
</ng-template>

<ng-template #meter>
  <td class='meter-column'>
    <div [style.minWidth.px]='meterColumnWidth' [style.width.px]='meterColumnWidth'  [hidden]='!lessonPrefs.meterShown'>
      <p [ngClass]='song.isNonduple ? "bold" : ""'>{{song.meter}}</p>
    </div>
  </td>
</ng-template>

<ng-template #swow>
  <td class='swow-column'>
    <div [style.minWidth.px]='swowColumnWidth' [style.width.px]='swowColumnWidth' [hidden]='!lessonPrefs.swowShown'>
      <button><i [ngClass]='lessonSongCssService.swowClass(song)'></i></button>
    </div>
  </td>
</ng-template>

<ng-template #activity let-textId>
  <td class='activity-column'>
    <div 
    [style.minWidth.px]='activityColumnWidth' 
    [style.width.px]='activityColumnWidth' 
    [hidden]='!lessonPrefs.activityShown'
    >
      <textarea
        id='{{textId}}' 
        [style.height]='cssUtilitiesService.textareaHeight(textId, 33)' 
        [(ngModel)]="this.activityText"
        (blur)="activityChanged()"
        [placeholder]="this.placeholder"
        (click)="onChangeActivity($event)"
        #textAreaActivity
      ></textarea>
    </div>
  </td>
</ng-template>

<ng-template #rp>
  <td class='rp-column'>
    <div *ngIf="!isSongCustom" [style.minWidth.px]='rpColumnWidth' [style.width.px]='rpColumnWidth' [hidden]='!lessonPrefs.rpShown'>
      <button *ngIf="lessonSongCssService.rpClass(song) !== ''" (click)='toggleRP()'><i [ngClass]="lessonSongCssService.rpClass(song)"></i></button>
    </div>
  </td>
</ng-template>

<ng-template #tp>
  <td class='tp-column'>
    <div *ngIf="!isSongCustom" [style.minWidth.px]='tpColumnWidth' [style.width.px]='tpColumnWidth' [hidden]='!lessonPrefs.tpShown'>
      <button *ngIf="lessonSongCssService.tpClass(song) !== ''" [hidden]='!song.tonality' (click)='toggleTP()'><i [ngClass]="lessonSongCssService.tpClass(song)"></i></button>
    </div>
  </td>
</ng-template>

<ng-template #instrument>
  <td class='instrument-column'>
    <div [style.minWidth.px]='instrumentColumnWidth' [style.width.px]='instrumentColumnWidth' [hidden]='!lessonPrefs.instrumentShown'>
      <button *ngIf="lessonSongCssService.instrumentClass(song) !== ''" (click)='toggleInstrument()'><i [ngClass]="lessonSongCssService.instrumentClass(song)"></i></button>
    </div>
  </td>
</ng-template>

<ng-template #recording>
  <td class='recording-column'>
    <div [style.minWidth.px]='recordingColumnWidth' [style.width.px]='recordingColumnWidth' [hidden]='!lessonPrefs.recordingShown'>
      <button *ngIf="lessonSongCssService.recordingClass(song) !== ''" (click)='isEditing ? chooseRecording() : playRecording.emit(song)'><i [ngClass]='lessonSongCssService.recordingClass(song)'></i></button>
    </div>
  </td>
</ng-template>

<ng-template #pem>
  <td class='pem-column'>
    <div [style.minWidth.px]='pemColumnWidth' [style.width.px]='pemColumnWidth' [hidden]='!lessonPrefs.pemShown'>
      <button *ngIf="lessonSongCssService.pemClass(song) !== ''" [ngClass]='lessonSongCssService.pemButtonClass(song)' (click)='togglePem.emit(song)'><i [ngClass]='lessonSongCssService.pemClass(song)'></i> {{pemButtonTitle()}}</button>
    </div>
  </td>
</ng-template>

<ng-template #info>
  <td class='info-column' #infoTd>
    <div [style.minWidth.px]='infoColumnWidth' [style.width.px]='infoColumnWidth'>
      <button (click)='showSongInfo.emit(song)'><i class='mt-info'></i></button>
      <!-- <i class='mt-remove' [hidden]='!isEditing' (click)='removeSong()'></i> -->
    </div>
  </td>
</ng-template>


<ng-container *ngIf='song && song.name && song.name.length > 0'>
  <td [ngClass]="{'name-column': true, 'draggable': isEditing}">
    <div [style.minWidth.px]='nameColumnWidth' [style.width.px]='nameColumnWidth' [ngClass]="{'draggable': isEditing}">
      <header [ngClass]="{'draggable': isEditing}">
        <!-- <button [ngClass]="{'drag-icon': true, 'white': song && song.name && song.name.length > 0}" [hidden]='!isEditing'>
          <img src='assets/imgs/hvmove.png'>
        </button> -->
        <p class='number'>{{index + 1}}</p>
      </header>
      <p>{{song.name.replace('(Teacher Mix)', '(TM)')}}</p>
    </div>
  </td>
  <ng-container [ngTemplateOutlet]='tonality'></ng-container>
  <ng-container [ngTemplateOutlet]='meter'></ng-container>
  <ng-container [ngTemplateOutlet]='swow'></ng-container>
  <ng-container [ngTemplateOutlet]='activity' [ngTemplateOutletContext]="{$implicit: ('activity' + song.uuid)}"></ng-container>
  <ng-container [ngTemplateOutlet]='rp'></ng-container>
  <ng-container [ngTemplateOutlet]='tp'></ng-container>
  <ng-container [ngTemplateOutlet]='instrument'></ng-container>
  <ng-container [ngTemplateOutlet]='recording'></ng-container>
  <ng-container [ngTemplateOutlet]='pem'></ng-container>
  <ng-container [ngTemplateOutlet]='info'></ng-container>
</ng-container>
<ng-container *ngIf='!song || !song.name || song.name.length === 0'  >
  <td class='number-column dashed-border'>
    <div>
      <p>{{index+1}} <span class="default-activity-text">{{ activityDefaultText() }}</span></p>
    </div>
  </td>
  <td class='spacer dashed-border hide-print' colspan='8'></td>
  <td class='add-column dashed-border hide-print' colspan='2'>
    <div>
      <button class='add-song' (click)='addSong.emit(index)'><i class='mt-plus'></i>Add Song</button>
    </div>
  </td>
</ng-container>